module.exports = __webpack_public_path__ + "assets/img/mv-sp.0be84b66.jpg";